export const CLIENT_COOKIE_NAME = "X-Authorization-ClientId";
export interface App {
  id: string;
  title: string;
}

export interface Settings {
  name: string;
  value: string;
}
